/**
 * Omni search component
 * 
 * @param bool extra: Whether to add in the extra "What is Omni" text.
 * 
 * Usage: <OmniSearch extra={false} />
 */

import React from 'react';
import PropTypes from 'prop-types';

import * as styles from 'src/uglib_styles/omniSearch.module.css'

function searchPrimo() {
    document.getElementById("primoQuery").value = "any,contains," + document.getElementById("primoQueryTemp").value.replace(/[,]/g, " ");
    document.forms["searchForm"].submit();
}

function OmniSearch (props) {
    let extra = <>
        <div className={styles.search_links}>
            <a className={styles.search_advanced} href="https://ocul-gue.primo.exlibrisgroup.com/discovery/search?vid=01OCUL_GUE:GUELPH&amp;lang=en&amp;mode=advanced">Advanced search</a>
        </div>
    </>;
    if (props.extra) {
        extra = <>
            <div className={styles.search_links}>
                <a className={styles.what_omni} href="https://guides.lib.uoguelph.ca/Omni">Getting started with Omni</a>
                <a className={styles.search_advanced} href="https://ocul-gue.primo.exlibrisgroup.com/discovery/search?vid=01OCUL_GUE:GUELPH&amp;lang=en&amp;mode=advanced">Advanced search</a>
            </div>
        </> 
    }

    return (
    <>
        <div className={styles.search_wrapper}>
            <div className="search-inner">
                <h2 className="sr-only">Search Omni</h2>
                <form className={styles.searchForm} name="searchForm" method="get" target="_self" action="https://ocul-gue.primo.exlibrisgroup.com/discovery/search" encType="application/x-www-form-urlencoded; charset=utf-8" onSubmit={searchPrimo} >
                    {/* <!-- Customizable Parameters --> */}
                    <input type="hidden" name="vid" value="01OCUL_GUE:GUELPH" />
                    <input type="hidden" name="tab" value="OCULDiscoveryNetwork" />
                    <input type="hidden" name="mode" value="basic" />

                    {/* <!-- Fixed parameters --> */}
                    <input type="hidden" name="displayMode" value="full" />
                    <input type="hidden" name="bulkSize" value="10" />
                    <input type="hidden" name="highlight" value="true" />
                    <input type="hidden" name="dum" value="true" />
                    <input type="hidden" name="query" id="primoQuery"/>
                    <input type="hidden" name="displayField" value="all" />
                    <input type="hidden" name="search_scope" value="OCULDiscoveryNetwork" />

                    {/* <!-- Enable this if "Expand My Results" is enabled by default in Views Wizard --> */}
                    <input type="hidden" name="pcAvailabiltyMode" value="true" />
                    
                    <label htmlFor="primoQueryTemp" className="sr-only">Search query</label>
                    <input name="primoQueryTemp" type="text" className={styles.search_field} id="primoQueryTemp" placeholder="Search Omni for books, journals, articles, videos..." />
                    <button className={styles.search_submit} onClick={searchPrimo} >
                        <span className="sr-only">Submit</span>
                        <span className="fa fa-search"></span>
                    </button>

                    {/* <!-- Search Button --> */}
                </form>
                {extra}
            </div>
        </div>
    </>);	
}

export default OmniSearch;

OmniSearch.propTypes = {
    extra: PropTypes.bool,
};

OmniSearch.defaultProps = {
    extra: true,
};